import { Controller } from "@hotwired/stimulus"

// Live preview inside the new-post modal: linkified text + local media thumbs.
// Nothing here fetches — the unfurl card only appears after the post is saved.
export default class extends Controller {
  static targets = ["body", "text", "thumbs", "files", "hint"]

  preview() {
    const raw = this.bodyTarget.value
    this.textTarget.innerHTML = this.escape(raw).replace(
      /(https?:\/\/[^\s<]+)/g,
      '<a class="text-accent-ink underline">$1</a>'
    )
  }

  files() {
    const files = [...this.filesTarget.files]
    const tooMany = files.length > 10
    const tooBig = files.some((f) => f.size > 50 * 1024 * 1024)
    this.hintTarget.classList.toggle("text-accent-ink", tooMany || tooBig)
    this.hintTarget.textContent =
      tooMany ? "Too many — 10 files max" :
      tooBig  ? "A file is over 50MB — post it as a link instead" :
                `${files.length} file(s) attached`

    this.thumbsTarget.innerHTML = ""
    files.forEach((file) => this.thumbsTarget.append(this.thumb(file)))
  }

  thumb(file) {
    const kind = file.type.split("/")[0]
    const url = URL.createObjectURL(file)
    let el
    if (kind === "image") {
      el = document.createElement("img")
      el.src = url
      el.className = "aspect-square w-full border-2 border-ink object-cover"
    } else if (kind === "video") {
      el = document.createElement("video")
      el.src = url
      el.className = "aspect-square w-full border-2 border-ink object-cover"
    } else {
      el = document.createElement("div")
      el.textContent = "♪ " + file.name
      el.className = "col-span-3 border-2 border-ink p-2 font-mono text-xs"
    }
    return el
  }

  submitted(event) {
    if (!event.detail.success) return
    this.element.reset()
    this.textTarget.innerHTML = ""
    this.thumbsTarget.innerHTML = ""
    this.hintTarget.textContent = "≤ 10 files · 50MB each · image/video/audio"
    this.element.closest("dialog")?.close()
  }

  escape(s) {
    const div = document.createElement("div")
    div.textContent = s
    return div.innerHTML
  }
}
